/**
 * Collection AJAX Filtering
 */

function updateFilters() {
  const form = document.getElementById('FacetFiltersForm');
  if (!form) return;

  const formData = new FormData(form);
  const queryString = new URLSearchParams(formData).toString();
  const url = `${window.location.pathname}?${queryString}`;

  // Update URL without reload
  history.pushState({ path: url }, '', url);

  // Visual feedback
  const resultsContainer = document.querySelector('.cc-filters-results');
  if (resultsContainer) resultsContainer.style.opacity = '0.5';

  fetch(url)
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      
      // Swap Product Grid
      const newResults = html.querySelector('.cc-filters-results');
      if (newResults && resultsContainer) {
        resultsContainer.innerHTML = newResults.innerHTML;
        resultsContainer.style.opacity = '1';
      }

      // Swap Filter Sidebar to update counts/checked states
      const oldSidebar = document.querySelector('#FacetFiltersForm');
      const newSidebar = html.querySelector('#FacetFiltersForm');
      if (oldSidebar && newSidebar) {
        oldSidebar.innerHTML = newSidebar.innerHTML;
      }

      // RE-INITIALIZE THEME SCRIPTS
      // Fix for images not showing up (if using lazysizes)
      if (window.lazySizes) {
        window.lazySizes.init();
      }
      
      // Optional: scroll back to top of results on mobile
      // window.scrollTo({ top: resultsContainer.offsetTop - 100, behavior: 'smooth' });
    })
    .catch(e => {
      console.error('Filter Error:', e);
      if (resultsContainer) resultsContainer.style.opacity = '1';
    });
}

/**
 * Mobile Drawer Controls
 */
function openFilterDrawer() {
  const drawer = document.getElementById("filterDrawer");
  const overlay = document.getElementById("filterOverlay");
  if (drawer && overlay) {
    drawer.classList.add("active");
    overlay.classList.add("active");
    document.body.style.overflow = "hidden";
  }
}

function closeFilterDrawer() {
  const drawer = document.getElementById("filterDrawer");
  const overlay = document.getElementById("filterOverlay");
  if (drawer && overlay) {
    drawer.classList.remove("active");
    overlay.classList.remove("active");
    document.body.style.overflow = "";
  }
}

// Handle Browser Back/Forward buttons
window.onpopstate = function() {
  location.reload();
};